import React, { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { BackgroundBlurProvider, MeetingProvider, useLogger } from 'amazon-chime-sdk-component-library-react';
import MeetingRoom from './meeting-room/MeetingRoom';
import WaitingRoom from './waiting-room/WaitingRoom';
import { LogLevel } from 'amazon-chime-sdk-js';
import { useDispatch } from 'react-redux';
import { hideHeader } from 'src/redux/actions/questionnaireActions';

const TeletherapyContainer: React.FC = () => {
  const loggers = useLogger();
  const dispatch = useDispatch();

  loggers.setLogLevel(LogLevel.OFF);
  useEffect(() => {
     dispatch(hideHeader(false));
  }, []);

  return (
    <>
      <BackgroundBlurProvider options={{ blurStrength: 10, logger: loggers  }}>
        <MeetingProvider>
          <Routes>
            <Route index={true} element={<Navigate to="waiting-room" replace={true} />} />
            <Route path="meeting-room" element={<MeetingRoom />} />
            <Route path="waiting-room" element={<WaitingRoom />} />
            <Route path="*" element={<Navigate to="waiting-room" replace={true} />} />
          </Routes>
        </MeetingProvider>
      </BackgroundBlurProvider>
    </>
  );
};

export default TeletherapyContainer;